import { render, staticRenderFns } from "./Saturation.vue?vue&type=template&id=17b259a5&scoped=true"
import script from "./Saturation.vue?vue&type=script&lang=js"
export * from "./Saturation.vue?vue&type=script&lang=js"
import style0 from "./Saturation.vue?vue&type=style&index=0&id=17b259a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b259a5",
  null
  
)

export default component.exports